import { ROW_LABEL_WIDTH, SEAT_CIRCLE_DIAMETER, SEAT_CIRCLE_RADIUS } from '../../constants';
import { getCircleIntersections, getCirclePoint, getClosestAngle, getDegreesBetweenPoints } from '../../utils/geometry';
import { radiansToDegrees360 } from '../../utils/utils';
const getObjectDegrees = (definition, objectRadius) => {
    const intersections = getCircleIntersections([
        { center: { x: 0, y: 0 }, radius: Math.abs(definition.curveRadius) },
        { center: { x: 0, y: definition.curveRadius }, radius: objectRadius },
    ]);
    const seatDegrees = getDegreesBetweenPoints(intersections[0], { x: 0, y: 0 }, intersections[1]);
    return seatDegrees;
};
export const getSeatDegrees = (definition) => getObjectDegrees(definition, SEAT_CIRCLE_RADIUS);
export const getRowDegrees = (definition) => {
    let from = radiansToDegrees360(definition.curveAngleFrom);
    const to = radiansToDegrees360(definition.curveAngleTo);
    if (from > to) {
        from -= 360;
    }
    const degrees = to - from;
    return degrees;
};
export const getRowLabelDegrees = (definition) => {
    // Some magic calculations based on observations of what looks nice
    const ADJUSTMENT_MAX = 4;
    const ADJUSTMENT_MIN = -1.5;
    let degrees = Math.abs(getRowDegrees(definition) % 360);
    if (degrees > 180) {
        degrees = 360 - degrees;
    }
    const diff = ADJUSTMENT_MAX - ADJUSTMENT_MIN;
    const adjustment = (diff / 180) * degrees + ADJUSTMENT_MIN;
    return getObjectDegrees(definition, ROW_LABEL_WIDTH / 2 + adjustment);
};
const getCurvedRowLabelPosition = (definition, left) => {
    const curveCircleCenter = { x: definition.midX, y: definition.curveRadius + SEAT_CIRCLE_RADIUS };
    const labelAngleDegrees = getRowLabelDegrees(definition);
    const from = radiansToDegrees360(definition.curveAngleFrom);
    const to = radiansToDegrees360(definition.curveAngleTo);
    const labelPositionDegrees = left ? from - labelAngleDegrees : to + labelAngleDegrees;
    const centerPosition = getCirclePoint(labelPositionDegrees, curveCircleCenter, definition.curveRadius);
    const position = {
        x: centerPosition.x - 10,
        y: centerPosition.y - SEAT_CIRCLE_RADIUS,
    };
    return position;
};
export const getLeftCurvedRowLabelPosition = (definition) => getCurvedRowLabelPosition(definition, true);
export const getRightCurvedRowLabelPosition = (definition) => getCurvedRowLabelPosition(definition, false);
export const getCurvedRowContainerInfo = (definition) => {
    const { curveAngleFrom, curveAngleTo } = definition;
    const fromDegrees = radiansToDegrees360(curveAngleFrom) % 360;
    const toDegrees = radiansToDegrees360(curveAngleTo) % 360;
    const leftSeatDegrees = getClosestAngle(fromDegrees, toDegrees, 270);
    const rightSeatDegrees = getClosestAngle(fromDegrees, toDegrees, 90);
    const bottomSeatDegrees = getClosestAngle(fromDegrees, toDegrees, 180);
    const center = { x: definition.midX, y: definition.curveRadius };
    const leftCenter = getCirclePoint(leftSeatDegrees, center, definition.curveRadius);
    const rightCenter = getCirclePoint(rightSeatDegrees, center, definition.curveRadius);
    const bottomCenter = getCirclePoint(bottomSeatDegrees, center, definition.curveRadius);
    const width = rightCenter.x - leftCenter.x + SEAT_CIRCLE_DIAMETER;
    const height = bottomCenter.y + SEAT_CIRCLE_DIAMETER;
    return { width, height };
};
//# sourceMappingURL=utils.js.map